import Chip, { ChipAfter, ChipContent } from "Components/Chip";
import React from "react";
import classes from "./styles.module.scss";
import InfoIcon from "../InfoIcon";
import { isClaimOptionVisible } from "../isClaimOptionVisible";

interface BadgeProps {
   isClaimable: LSCommon.Service.LSWebUI.Models.XPP.Claimable;
   onClaim: () => void;
}

export const Badge: React.FC<BadgeProps> = ({ isClaimable, onClaim }) => {
   return isClaimOptionVisible(isClaimable)
      ? <div className={classes.container}>
         <Chip size="lg">
            <ChipContent className="h7">Unclaimed</ChipContent>
            <ChipAfter>
               <InfoIcon onClaim={onClaim} tooltipPlacement="right" size={16} />
            </ChipAfter>
         </Chip>
      </div>
      : null
}

export default Badge;

